export var Locations;
(function (Locations) {
    function bindScope(client) {
        return {
            DownloadLocationCheckpointScans: client.bindCallable({
                name: 'DownloadLocationCheckpointScans',
                scope: 'locations',
                path: '/api/locations/download-location-checkpoint-scans',
                method: 'post',
                kind: 'api',
            }),
            DownloadLocationCheckpointTours: client.bindCallable({
                name: 'DownloadLocationCheckpointTours',
                scope: 'locations',
                path: '/api/locations/download-location-checkpoint-tours',
                method: 'post',
                kind: 'api',
            }),
            DownloadLocationLogEntries: client.bindCallable({
                name: 'DownloadLocationLogEntries',
                scope: 'locations',
                path: '/api/locations/download-location-log-entries',
                method: 'post',
                kind: 'api',
            }),
            DownloadLocationLogEntry: client.bindCallable({
                name: 'DownloadLocationLogEntry',
                scope: 'locations',
                path: '/api/locations/download-location-log-entry',
                method: 'post',
                kind: 'api',
            }),
        };
    }
    Locations.bindScope = bindScope;
})(Locations || (Locations = {}));
//# sourceMappingURL=locations.js.map